var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"abs-center-box logo-img-box"},[_c('img',{attrs:{"src":_vm.logoUrl,"ondragstart":"return false;"}})])}
var staticRenderFns = []

export { render, staticRenderFns }